import React from 'react'
import PropTypes from 'prop-types'

import {
  Dialog as MaterialDialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
} from '@material-ui/core'

import ConfirmDialogContext from 'contexts/ConfirmDialogContext'

const initial = {
  visible: false,
  title: '',
  message: '',
  cancelButton: 'Cancelar',
  confirmButton: 'Confirmar',
  handleConfirm: e => {},
}

const ConfirmDialogProvider = ({ children }) => {
  const [state, setState] = React.useState(initial)

  const handleClose = () => {
    setState({ ...state, visible: false })
  }

  const handleOpen = params => {
    setState({ ...initial, ...params, visible: true })
  }

  const handleConfirm = e => {
    state.handleConfirm(e)
    handleClose()
  }

  return (
    <ConfirmDialogContext.Provider value={{ open: handleOpen }}>
      {children}

      <MaterialDialog
        open={state.visible}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <div>
            <Typography variant="h4">{state.title}</Typography>
          </div>
        </DialogTitle>
        <DialogContent>
          {typeof state.message === 'string' ? (
            <DialogContentText>{state.message}</DialogContentText>
          ) : (
            <state.message />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={handleConfirm}
            autoFocus
          >
            {state.confirmButton}
          </Button>
          <Button variant="outlined" color="primary" onClick={handleClose}>
            {state.cancelButton}
          </Button>
        </DialogActions>
      </MaterialDialog>
    </ConfirmDialogContext.Provider>
  )
}

ConfirmDialogProvider.propTypes = {
  children: PropTypes.node,
}

export default ConfirmDialogProvider
